import { Dispatch } from 'redux';

export const SHOW_ARTIST_OVERVIEW = 'SHOW_ARTIST_OVERVIEW';
export const CLOSE_ARTIST_OVERVIEW = 'CLOSE_ARTIST_OVERVIEW';
export const SHOW_ARTIST_SETTINGS = 'SHOW_ARTIST_SETTINGS';
export const CLOSE_ARTIST_SETTINGS = 'CLOSE_ARTIST_SETTINGS';

export const initialState: TState = {
  showArtistsOverview: false,
  showArtistSettings: false,
  activeArtist: undefined,
};

export default reducer;
export {
  setShowArtistsOverview,
  setShowArtistSettings,
  setCloseArtistSettings,
  setCloseArtistsOverview,
};

function reducer(state: TState = initialState, action: TAction): TState {
  switch (action.type) {
    case SHOW_ARTIST_OVERVIEW:
      return {
        showArtistsOverview: true,
        showArtistSettings: false,
        activeArtist: undefined,
      };
    case SHOW_ARTIST_SETTINGS:
      return {
        showArtistsOverview: false,
        showArtistSettings: true,
        activeArtist: action.activeArtist,
      };
    case CLOSE_ARTIST_OVERVIEW:
    case CLOSE_ARTIST_SETTINGS:
      return {
        showArtistsOverview: false,
        showArtistSettings: false,
        activeArtist: undefined,
      };
    default:
      return state;
  }
}

function setShowArtistSettings(artist: TArtist) {
  return function (dispatch: Dispatch): any {
    return dispatch({ type: SHOW_ARTIST_SETTINGS, activeArtist: artist });
  };
}

function setShowArtistsOverview() {
  return function (dispatch: Dispatch): any {
    return dispatch({ type: SHOW_ARTIST_OVERVIEW });
  };
}

function setCloseArtistsOverview() {
  return function (dispatch: Dispatch): any {
    return dispatch({ type: CLOSE_ARTIST_OVERVIEW });
  };
}

function setCloseArtistSettings() {
  return function (dispatch: Dispatch): any {
    return dispatch({ type: CLOSE_ARTIST_SETTINGS });
  };
}

export type TArtist = { entityId: string; entityName: string };

// Both modals can not be open at the same time.
// When `showArtistSettings` is true, activeArtist should be valid.
type TState =
  | {
      showArtistsOverview: true;
      showArtistSettings: false;
      activeArtist: undefined;
    }
  | {
      showArtistsOverview: false;
      showArtistSettings: true;
      activeArtist: TArtist;
    }
  | {
      showArtistsOverview: false;
      showArtistSettings: false;
      activeArtist: undefined;
    };

type TAction =
  | { type: typeof SHOW_ARTIST_SETTINGS; activeArtist: TArtist }
  | { type: typeof SHOW_ARTIST_OVERVIEW }
  | { type: typeof CLOSE_ARTIST_OVERVIEW }
  | { type: typeof CLOSE_ARTIST_SETTINGS };
